import {
  blackVariants,
  blueDeepVariants,
  limeGreenVariants,
  redVariants,
  violetVariants,
  yellowVariants
} from '@/themes/colors'
import type { BaseStatusVariant } from '@/types/status.types'

export const getColorFromVariant = (
  variant: BaseStatusVariant
): {
  mainColor: string
  gradientColor: string
} => {
  switch (variant) {
    case 'default':
      return {
        mainColor: blackVariants[900],
        gradientColor: blackVariants[50]
      }
    case 'success':
      return {
        mainColor: limeGreenVariants[800],
        gradientColor: limeGreenVariants[100]
      }
    case 'info':
      return {
        mainColor: blueDeepVariants[900],
        gradientColor: violetVariants[100]
      }
    case 'warning':
      return {
        mainColor: yellowVariants[900],
        gradientColor: yellowVariants[100]
      }
    case 'error':
      return {
        mainColor: redVariants[900],
        gradientColor: redVariants[100]
      }
  }
}
